import { RefreshCw, X } from 'lucide-react';
import { useI18n } from '@/shared/i18n';

interface ConfirmChangeVoteModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmChangeVoteModal: React.FC<ConfirmChangeVoteModalProps> = ({
  onConfirm,
  onCancel,
}) => {
  const { t } = useI18n();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-violet-100 rounded-lg">
              <RefreshCw size={20} className="text-violet-600" />
            </div>
            <h3 className="font-bold text-slate-800">
              {t('polls.changeVoteConfirm.title')}
            </h3>
          </div>
          <button
            onClick={onCancel}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
          >
            <X size={20} className="text-slate-400" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5">
          <p className="text-slate-600 text-sm">
            {t('polls.changeVoteConfirm.message')}
          </p>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-5 pt-0">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 text-slate-600 font-medium bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors"
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white font-medium rounded-lg transition-colors"
          >
            {t('polls.changeVoteConfirm.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};
